import React from "react";
import CBNLogo from "../../assets/images/cbn.png";
import NDICLogo from "../../assets/images/ndic2.png";

var d = new Date();
var year = d.getFullYear();

const BottomFooter = () => {
    return (
        <React.Fragment>
            <footer className="footer-wrapper text-white">
                <div className="inner">
                    <p> Copyright © {year}. eTranzact All rights reserved.</p>
                    <div className="logo-container">
                        <p>
                            CorporatePay is licensed by the Central Bank of Nigeria and insured by
                            NDIC
                        </p>
                        <img className="img-fluid cbn" src={CBNLogo} alt="cbn-logo" />
                        <img className="img-fluid ndic" src={NDICLogo} alt="ndic-logo" />
                    </div>
                </div>
            </footer>
        </React.Fragment>
    );
};

export default BottomFooter;
